/**
 * Returns true when a music_user_genre_name matches a given filter. In terms of the UI, anything
 * that is not 'broadcast' is considered to be 'digital', even though there are actually several
 * other possible values for music_user_genre_name.
 * @param musicUserGenreName a music_user_genre_name, i.e. 'broadcast', 'digital', 'miscellaneous',
 * @param filter either 'broadcast' or 'digital'
 */
export const genreMatchesFilter = (
    musicUserGenreName: string | null | undefined,
    filter: BroadcastOrDigital,
): boolean => {
    if (!musicUserGenreName) {
        return false;
    }

    if (filter === 'digital' && musicUserGenreName === 'digital') {
        return true;
    }
    if (filter !== 'digital' && musicUserGenreName !== 'digital') {
        return true;
    }

    return false;
};
